module.exports = __webpack_public_path__ + "img/satellite.60e87b6a.jpg";